// extracted by mini-css-extract-plugin
export default {"edit-chapter-sidebar":"EditChapterSidebar_edit-chapter-sidebar__VyHr1"};